import bgOranum from './assets/bgOranum.jpg';
import bgOranumMobile from './assets/bgMobileOranum.jpg';

interface Content {
    bg: string;
    bgMobile: string;
}

const oranumContent: Content = {
    bg: bgOranum,
    bgMobile: bgOranumMobile,
};

// eslint-disable-next-line import/prefer-default-export
export const getContent = () => {
    return oranumContent;
};
